import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const CheckmarkIcon = styled.div`
    color: ${theme.colors.foreground.onEmphasis};
    border-radius: ${theme.radii[4]};
    width: 18px;
    height: 18px;
`;
